// Dependencies
import React, {Component} from "react";
import {connect} from "react-redux";
import {TransitionGroup, CSSTransition} from "react-transition-group";
import {RouteComponentProps, withRouter} from "react-router-dom";
import _ from "lodash";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";

// Store
import {ActionCreator} from "../../../../actions/actions";
import {Subsidiary} from "../../../../types/types";
import {mailingStoreSelectors} from "../../store/store";
import {MailingActionCreators} from "../../actions/actionCreators";
import {baseConfigInitialFields} from "../Schemas/MailingSchemas";

// Styles
import "./MailingConfiguration.component.scss";

//Components
import Form from "../../../../utils/forms/components/Form";
import {Dialog} from "../../../../utils/Dialog/Dialog.component";
import {SubsidiaryUtils} from "../../../../utils/Subsidiary/SubsidiaryUtils";
import {checkPermission} from "../../../../utils/Authorization/authorization";

export interface MailingConfigurationProps extends RouteComponentProps {
    getMailing: ActionCreator;
    mailingListLoading: boolean;
    editingMailingList: any;
    updateMailingLists: ActionCreator;
    editMailingList: ActionCreator;
    addMailingList: ActionCreator;
    submittingMailingListState: any;
    submitMailingListLoading: boolean;
    clearMailingList: ActionCreator;
    clearSubmitMailingList: ActionCreator;

    getSubsidiaries: ActionCreator;
    subsidiariesList: Subsidiary[];
    subsidiariesLoading: boolean;

    initialPreset: any;

    getMailingTypes: ActionCreator;
    mailingTypes: any[];
    mailingTypesLoading: boolean;
}

export interface MailingConfigurationState {
    baseFormCurrentValues: {};
    mailingListFormCurrentValues: any[];
    showTypesList: boolean;
    showDeleteListNotification: boolean;
    listToDelete: any;
}

const validateEmail = email => {
    const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

class MailingConfiguration extends Component<
    MailingConfigurationProps,
    MailingConfigurationState
> {

    baseForm: React.RefObject<Form>;
    isDetail: boolean;
    isEdit: boolean;

    constructor(props) {
        super(props);

        this.props.clearMailingList();

        this.props.getSubsidiaries();
        this.props.getMailingTypes();

        this.isDetail = this.props.match.path.includes("/detail");
        this.isEdit = this.props.match.path.includes("/edit");

        if (this.isDetail || this.isEdit) {
            if (!this.props.match.params["presetId"]) {
                this.props.history.push(`/admin/mailing`);
            } else {
                this.props.getMailing(this.props.match.params["presetId"]);
            }
        }

        this.state = {
            baseFormCurrentValues: {
                name: "",
                subsidiary: ""
            },
            mailingListFormCurrentValues: [],
            showTypesList: false,
            showDeleteListNotification: false,
            listToDelete: null
        };
    }

    cancelConfig = () => {
        this.props.clearMailingList();
        this.props.history.push(`/admin/mailing`);
    };

    onChangeBaseForm = data => {
        this.setState({baseFormCurrentValues: data.values});
    };

    cancelAddList = () => {
        this.setState({showTypesList: false});
    };

    addTypeList = type => {
        const mailingList = this.props.editingMailingList

        const newLists = this.props.editingMailingList["lists"] ? [...this.props.editingMailingList.lists] : [];
        newLists.push({
            name: type.name,
            key: type.key,
            mails: []
        });
        mailingList["lists"] = newLists
        this.setState({mailingListFormCurrentValues: newLists});
        this.props.updateMailingLists(mailingList);
        this.cancelAddList();
    };


    confirmDeleteListType = list => {
        this.setState({
            showDeleteListNotification: true,
            listToDelete: list
        });
    };

    deleteListType = () => {
        const mailingList = this.props.editingMailingList

        const newLists = [...this.props.editingMailingList.lists];
        const listIndex = newLists.findIndex(list =>
            _.isEqual(list, this.state.listToDelete)
        );
        if (listIndex > -1) {
            newLists.splice(listIndex, 1);
            mailingList["lists"] = newLists
            this.props.updateMailingLists(mailingList);
            this.closeDeleteList();
        }
    };

    closeDeleteList = () => {
        this.setState({
            showDeleteListNotification: false,
            listToDelete: null
        });
    };

    addMailToList = list => {
        const mailingList = this.props.editingMailingList
        const newList = {...list};
        newList.mails.push({
            removable: true,
            address: ""
        });
        const updateListIndex = this.props.editingMailingList.lists.findIndex(
            listInObject => listInObject.name == list.name
        );
        if (updateListIndex > -1) {
            const newLists = [...this.props.editingMailingList.lists];
            newLists[updateListIndex] = newList;
            mailingList["lists"] = newLists
            this.props.updateMailingLists(mailingList);
        }
    };

    changeMailRemovable = (value, list, index) => {
        const mailingList = this.props.editingMailingList
        let newList = {...list};
        const updateIndex = index;
        if (
            updateIndex > -1 &&
            newList.mails[updateIndex].removable !== value
        ) {
            newList.mails[updateIndex].removable = value;
        }
        const updateListIndex = this.props.editingMailingList.lists.findIndex(
            listInObject => listInObject.name == list.name
        );

        const newLists = [...this.props.editingMailingList.lists];
        newLists[updateListIndex] = newList;
        if (
            updateIndex > -1 &&
            newList.mails[updateIndex].removable !== value
        ) {
            mailingList["lists"] = newLists
            this.props.updateMailingLists(mailingList);
        }
    };

    changeMail = (value, list, index) => {
        const mailingList = this.props.editingMailingList
        const newList = {...list};
        const updateIndex = index;
        if (updateIndex > -1) {
            newList.mails[updateIndex].address = value.target.value;
        }
        const updateListIndex = this.props.editingMailingList.lists.findIndex(
            listInObject => listInObject.name == list.name
        );
        if (updateListIndex > -1) {
            const newLists = [...this.props.editingMailingList.lists];
            newLists[updateListIndex] = newList;
            mailingList["lists"] = newLists
            this.props.updateMailingLists(mailingList);
        }
    };

    deleteMailFromList = (list, index) => {
        const mailingList = this.props.editingMailingList
        const newList = {...list};
        const deleteIndex = index;
        if (deleteIndex > -1) {
            newList.mails.splice(deleteIndex, 1);
        }

        const updateListIndex = this.props.editingMailingList.lists.findIndex(
            listInObject => listInObject.name == list.name
        );
        if (updateListIndex > -1) {
            const newLists = [...this.props.editingMailingList.lists];
            newLists[updateListIndex] = newList;
            mailingList["lists"] = newLists
            this.props.updateMailingLists(mailingList);
        }
    };

    hasDuplicates = a => {
        return _.uniq(a).length !== a.length;
    };

    submitMailingListForm = () => {
        if (!this.props.submitMailingListLoading) {
            let mailingList = this.state.baseFormCurrentValues
            mailingList['lists'] = this.props.editingMailingList.lists
            if (this.isEdit || this.props.editingMailingList.id) {
                this.props.editMailingList({
                    mailingList: mailingList,
                    id: this.props.editingMailingList.id
                });
                this.isEdit = true
            } else {
                this.props.addMailingList({
                    mailingList: mailingList
                });
            }
        }
    }

    renderList = list => {
        let listMailHasError = false;
        const mails = list.mails.map(mail => {
            return mail.address;
        });
        let duplicated = this.hasDuplicates(mails);
        const occurrences = mails.reduce(function (acc, curr) {
            return acc[curr] ? ++acc[curr] : (acc[curr] = 1), acc;
        }, {});

        return (
            <div key={list.name} className="col-6">
                <div className="list">
                    <div className="list-header">
                        {!this.isDetail && (
                            <button
                                className="delete-list-button"
                                onClick={() => this.confirmDeleteListType(list)}
                            >
                                <i className="icon-trash-alt-light"/>
                            </button>
                        )}
                        <span>{list.name}</span>
                        {!this.isDetail && (
                            <button onClick={() => this.addMailToList(list)}>
                                <i className="icon-plus-light"/>
                            </button>
                        )}
                    </div>

                    <div className="list-body">
                        <table>
                            <thead>
                            <tr>
                                <th>Removable</th>
                                <th>Address</th>
                                {!this.isDetail && (<th>Remove</th>)}
                            </tr>
                            </thead>
                            <tbody>
                            {list.mails.map((mail, index) => {
                                const mailIsValid = validateEmail(
                                    mail.address
                                );

                                if (!mailIsValid && !duplicated)
                                    listMailHasError = true;
                                const mailIsDuplicated = duplicated
                                    ? occurrences[mail.address] > 1
                                    : false;

                                return (
                                    <tr key={`${index}`}>
                                        <td
                                            className={`${
                                                !checkPermission(
                                                    "edit_mailing_list"
                                                ) || this.isDetail
                                                    ? "disabled-intereaction"
                                                    : ""
                                            }`}
                                        >
                                            <Components.Checkbox
                                                checked={mail.removable}
                                                onChange={value =>
                                                    this.changeMailRemovable(
                                                        value,
                                                        list,
                                                        index
                                                    )
                                                }
                                            />
                                        </td>
                                        <td>
                                            <input
                                                placeholder="Email Address"
                                                type="email"
                                                name={`${_.uniqueId()}`}
                                                autoComplete="chrome-off"
                                                value={mail.address}
                                                disabled={
                                                    !checkPermission(
                                                        "edit_mailing_list"
                                                    ) || this.isDetail
                                                }
                                                className={`${
                                                    mailIsDuplicated
                                                        ? "invalid"
                                                        : duplicated
                                                            ? "valid"
                                                            : mailIsValid
                                                                ? "valid"
                                                                : "invalid"
                                                }`}
                                                onChange={value =>
                                                    this.changeMail(
                                                        value,
                                                        list,
                                                        index
                                                    )
                                                }
                                            />
                                        </td>
                                        {!this.isDetail && (
                                            <td>
                                                <button
                                                    onClick={() =>
                                                        this.deleteMailFromList(
                                                            list,
                                                            index
                                                        )
                                                    }
                                                >
                                                    <i className="icon-trash-alt-light"/>
                                                </button>
                                            </td>
                                        )}
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
                {listMailHasError && (
                    <p className="error-list">
                        One or more entries are not a valid e-mail address.
                        Addresses marked with an error border will be deleted on
                        save.submitMailingListForm
                    </p>
                )}
                {duplicated && (
                    <p className="error-list">
                        Addresses marked with an error border are duplicated.
                        Please keep only one entry.
                    </p>
                )}
            </div>
        );
    }

    render() {
        if (
            this.props.subsidiariesList.length == 0 ||
            this.props.subsidiariesLoading ||
            this.props.mailingTypesLoading ||
            this.props.mailingListLoading
        ) {
            return (
                <div id="MailingConfiguration">
                    <div className="loading" key="loading">
                        <Components.LoadingRipple width={100} height={100}/>
                    </div>
                </div>
            );
        } else if (
            (this.isDetail || this.isEdit) &&
            (Object.keys(this.props.editingMailingList).length === 0)
        ) {
            return (
                <div id="MailingConfiguration" className="visible">
                    <div className="sidebar-layout">
                        <div className="container header" style={{textAlign: "end"}}>
                            <button onClick={this.cancelConfig}>
                                Cancel
                            </button>
                        </div>
                    </div>
                    <div className="error-config">
                        Mailing List does not exist.
                    </div>
                </div>
            )
        }
        const isBaseFormValid =
            this.state.baseFormCurrentValues["name"] !== undefined &&
            this.state.baseFormCurrentValues["name"] !== "" &&
            this.state.baseFormCurrentValues["subsidiary"] !== undefined &&
            this.state.baseFormCurrentValues["subsidiary"] !== ""

        let filteredTypes = this.props.mailingTypes;
        if (this.props.editingMailingList && this.props.editingMailingList["lists"]) {
            const currentListsKeys = this.props.editingMailingList.lists.map(
                list => list.key
            );
            filteredTypes = this.props.mailingTypes.filter(
                type => !currentListsKeys.includes(type.key)
            );
        }

        let isListFormValid = false
        if (this.props.editingMailingList && this.props.editingMailingList["lists"]) {
            let listMailHasError = false;
            const mails = this.props.editingMailingList.lists.map(
                list => {
                    if (list.mails.length === 0) {
                        listMailHasError = true;
                    }
                    return list.mails.map(mail => {
                        if (!validateEmail(mail.address)) {
                            listMailHasError = true;
                        }
                        return mail.address;
                    });
                }
            );
            let duplicated = this.hasDuplicates(mails);
            isListFormValid = !listMailHasError && !duplicated && this.props.editingMailingList["lists"].length > 0
        }

        return (
            <div id="MailingConfiguration">
                <div className="sidebar-layout">
                    <div className="config-content">
                        <div className="container header">
                            <h1>
                                {this.isEdit
                                    ? `Editing Mailing List ${this.props.editingMailingList.name}`
                                    : this.isDetail
                                        ? `Mailing List ${this.props.editingMailingList.name} - Details`
                                        : "New Mailing List"}
                            </h1>
                            <button onClick={this.cancelConfig}>
                                Cancel
                            </button>
                        </div>
                        <div className={`container ${this.isDetail ? "readonly" : ""}`}>
                            <TransitionGroup>
                                <CSSTransition
                                    key={"mailing-config"}
                                    timeout={600}
                                    classNames="fade-tabs"
                                >
                                    <div className="form-content">
                                        <div className="inner-card">
                                            <div className="inner-card-title">
                                                Base
                                                <span
                                                    className={`form-validation-icon ${isBaseFormValid
                                                        ? "valid"
                                                        : "invalid"
                                                    }`}
                                                >
                                                    {isBaseFormValid ?
                                                        <i className="icon-check-circle" />
                                                        : <i className="icon-times-circle-solid"/>}

                                                </span>
                                            </div>
                                            <div className="inner-card-content">
                                                <Form
                                                    key={`${this.state.baseFormCurrentValues["subsidiary"]}`}
                                                    ref={this.baseForm}
                                                    fields={baseConfigInitialFields(
                                                        {
                                                            subsidiaries:
                                                                SubsidiaryUtils.subsidiarySelectItems(
                                                                    this
                                                                        .props
                                                                        .subsidiariesList
                                                                ),
                                                            isDisabled: this.isEdit
                                                        }
                                                    )}
                                                    initialValues={
                                                        this.isDetail ||
                                                        this.isEdit
                                                            ? this.props.editingMailingList
                                                            : this.state.baseFormCurrentValues
                                                    }
                                                    onChange={this.onChangeBaseForm}
                                                />
                                            </div>
                                        </div>
                                        <div className="inner-card">
                                            <div className="inner-card-title">
                                                Mailing List
                                                <span
                                                    className={`form-validation-icon ${isListFormValid
                                                        ? "valid"
                                                        : "invalid"
                                                    }`}
                                                >
                                                    {isListFormValid ?
                                                        <i className="icon-check-circle" />
                                                        : <i className="icon-times-circle-solid"/>}
                                                </span>
                                            </div>
                                            <div className="inner-card-content">
                                                {!this.isDetail && (
                                                    <div className="add-type-list">
                                                        <button
                                                            className="red-btn"
                                                            onClick={() => {
                                                                this.setState({
                                                                    showTypesList: true
                                                                });
                                                            }}
                                                        >
                                                            <i className="icon-plus-light"/>{" "}
                                                            Add List from Type
                                                        </button>
                                                    </div>
                                                )}
                                                <Dialog
                                                    open={this.state.showTypesList}
                                                    onConfirm={this.cancelAddList}
                                                    onClose={this.cancelAddList}
                                                    hideCancel={true}
                                                    confirmLabel="Cancel"
                                                    addedClassName={"add-type-dialog"}
                                                >
                                                    <div>
                                                        <h3>Available Types</h3>
                                                        <p>Pick a mailing list type to add:</p>
                                                        <ul>
                                                            {filteredTypes.map(type => {
                                                                return (
                                                                    <li
                                                                        onClick={() => this.addTypeList(type)}
                                                                        key={type.key}
                                                                    >
                                                                        {type.name}
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    </div>
                                                </Dialog>

                                                <Dialog
                                                    open={this.state.showDeleteListNotification}
                                                    onConfirm={this.deleteListType}
                                                    onClose={this.closeDeleteList}
                                                >
                                                    You are about to delete a list type. All e-mails and options
                                                    selected for this list will be lost. Do you want to
                                                    continue?
                                                </Dialog>

                                                <div className="list-objects">
                                                    {this.props.editingMailingList &&
                                                        this.props.editingMailingList["lists"] &&
                                                        this.props.editingMailingList["lists"].length >
                                                        0 &&
                                                        this.props.editingMailingList.lists.map(list =>
                                                            this.renderList(list)
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </CSSTransition>
                            </TransitionGroup>
                        </div>
                        {!this.isDetail && (
                            <div className={`navigation container`}>
                                <button
                                    className={`next ${this.props.submitMailingListLoading
                                        ? "loading"
                                        : ""
                                    }`}
                                    disabled={
                                        !isListFormValid ||
                                        !isBaseFormValid
                                    }
                                    onClick={this.submitMailingListForm}
                                >
                                    {this.isEdit ? "Save" : "Create"}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                {this.props.submittingMailingListState && (
                    <Dialog
                        open={
                            !this.props.submittingMailingListState.error &&
                            this.props.submittingMailingListState.success
                        }
                        onClose={() => {
                            this.props.clearSubmitMailingList();
                        }}
                        onConfirm={() => {
                            this.cancelConfig()
                        }}
                        addedClassName={"presets-success-dialog"}
                        confirmLabel={"Go to Mailing lists"}
                        cancelLabel={"Review mailing list form"}
                    >
                        <img
                            src="/images/hurray.png"
                            width="268"
                            height="230"
                        />
                        <div>
                            <h2>Your mailing list is {this.isEdit ? 'updated' : 'created'}!</h2>
                            <p>
                                Congratulations, your mailing list has been
                                successfully {this.isEdit ? 'updated' : 'created'}. Thank you for your time!
                            </p>
                        </div>
                    </Dialog>
                )}
            </div>
        )
    }

}


const mapStateToProps = state => ({
    editingMailingList: mailingStoreSelectors.editingMailingList(state),
    submittingMailingListState: mailingStoreSelectors.submittingMailingListState(state),
    submitMailingListLoading: mailingStoreSelectors.submitMailingListLoading(state),
    subsidiariesList: mailingStoreSelectors.subsidiaries(state),
    subsidiariesLoading: mailingStoreSelectors.subsidiariesLoading(state),
    mailingTypes: mailingStoreSelectors.mailingTypes(state),
    mailingTypesLoading: mailingStoreSelectors.mailingTypesLoading(state),
    mailingListLoading: mailingStoreSelectors.mailingListLoading(state)
});

const mapDispatchToProps = {
    getSubsidiaries: MailingActionCreators.getSubsidiaries,
    getMailingTypes: MailingActionCreators.getMailingTypes,
    getMailing: MailingActionCreators.getMailing,
    updateMailingLists: MailingActionCreators.updateMailingLists,
    editMailingList: MailingActionCreators.editMailingList,
    addMailingList: MailingActionCreators.addMailingList,
    clearMailingList: MailingActionCreators.clearMailingList,
    clearSubmitMailingList: MailingActionCreators.clearSubmitMailingList,

};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(MailingConfiguration));
